import React, { useState, useEffect } from 'react'; //eslint-disable-line
import { useParams } from 'react-router-dom';
import InputBase from '@mui/material/InputBase';
import Pagination from '@mui/material/Pagination';
import CategoryTreeView from '../../components/tree-view/CategoryList';
import CategoryProductList from '../../components/tree-view/CategoryProductList';
import CategoryBreadCrumb from './CategoryBreadCrumb';

export default function Index() {
  const [categoryPath, setCategoryPath] = useState([]); //eslint-disable-line
  const { root, child, subChild } = useParams();
  const updatePath = (elt) => {
    setCategoryPath((prev) => [...prev, elt]);
  };
  useEffect(() => {
    setCategoryPath([]);
    console.log({ root, child, subChild });
    if (root) {
      const [rootName, rootID] = root.split('-');
      updatePath({ name: rootName, id: rootID });
      if (child) {
        const [childName, childID] = child.split('-');
        updatePath({ name: childName, id: childID });
        if (subChild) {
          const [subChildName, subChildID] = subChild.split('-');
          updatePath({ name: subChildName, id: subChildID });
        }
      }
    }
  }, [root, child, subChild]);
  useEffect(() => {
    console.log({
      root,
      categoryPath,
    });
  }, [categoryPath]);

  return (
    <section
      className="flex flex-col py-14 md:px-5 md:gap-x-3"
    >
      <CategoryBreadCrumb categoryPath={categoryPath} />
      <div className="flex">
        <aside className="hidden basis-1/4 md:flex flex-col gap-y-3 bg-white items-center min-h-[600px]">
          <h3 className="uppercase pt-3 font-serif text-main">
            Category filter
          </h3>
          <InputBase
            placeholder="Enter category name"
            className="mb-3 border-2 pt-1 px-2 w-[90%] active:shadow-md"
          />
          <div className="w-[90%]">
            <CategoryTreeView />
          </div>
        </aside>
        <main className="w-full md:basis-3/4 flex flex-col gap-y-5 bg-white items-center py-5">
          <h3 className="uppercase font-serif text-main">Medical Equipment</h3>
          <hr className="text-main w-full" />
          <ul className="grid grid-cols-1 gap-1 w-full bg-gray-50
                        sm:gap-3 sm:px-1 sm:py-3
                        sm:flex sm:flex-row sm:flex-wrap sm:gap-0
                        md:grid md:grid-cols-3 md:gap-1
                        md:mx-auto"
          >
            <CategoryProductList />
          </ul>
          <hr className="w-full" />
          <Pagination count={10} />
        </main>
      </div>
    </section>
  );
}
